// Bump tier colours.
//
// These distinguish a paid super bump from a bump in the queue, so they carry
// product meaning rather than decoration. They were duplicated as string
// literals in PlayerView and CollapsableVideoListItem; holding them here stops
// the two copies drifting apart.
//
// Mirrored in src/sass/_palette.scss as $jk-super-bump-gold and
// $jk-bump-silver — change both together.

export const superBumpGold = '#f6c357';
export const bumpSilver = '#b0b0b0';
